(function (scope) {

scope.DisableBlankAHREFHashClicks = function () {
	$("a[href]").each (function () {
		var hash = $(this).attr ("href");
		hash = hash.split (window.location.pathname).join ("");
		hash = hash.split (window.location.search).join ("");
		// var href2 = $(this).prop ("href");
		// var href3 = $(this)[0].getAttribute ("href");;
		// console.log (href);
		// console.log (href2);
		// console.log (href3);
		var hashId = hash.split ("#")[1];
		// console.log ("DisableAHREFHashClicks", hash);
		if (hash && hashId == "") {
			$(this).on ("click.DisableAHREFHashClicks", function (e) {
				// console.log ("DisableAHREFHashClicks", this, "disabled!");
				e.preventDefault ();
				return false;
			});
		}
	});
}

}) (window);
